module.exports = __webpack_public_path__ + "static/media/maria-srdce.4e4286ab.jpg";